if (!customElements.get('alvez-sidebar')) {
  customElements.define('alvez-sidebar', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.alvez-sidebar__trigger');
      this.closeButton = this.querySelector('.alvez-sidebar__close');
      this.trigger.addEventListener('click', () => this.open(), options);
      this.closeButton.addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.close();
      }, options);
      this.dialog.addEventListener('cancel', event => {
        event.preventDefault();
        this.close();
      }, options);
      this.dialog.addEventListener('close', () => this.cleanup(), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button, a[href]')];
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      // Identify the current destination without marking every New In sort view.
      this.querySelectorAll('nav a').forEach(link => {
        const url = new URL(link.href);
        if (url.pathname === location.pathname && url.search === location.search) {
          link.setAttribute('aria-current', 'page');
        }
      });
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      document.documentElement.classList.add('alvez-sidebar-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.dialog.getBoundingClientRect();
      this.dialog.classList.add('is-open');
    }

    close() {
      if (!this.dialog.open || this.closeTimer) return;
      this.dialog.classList.remove('is-open');
      const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260;
      this.closeTimer = setTimeout(() => {
        this.dialog.close();
        this.cleanup();
      }, delay);
    }

    cleanup() {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
      this.dialog.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('alvez-sidebar-open');
    }

    disconnectedCallback() {
      if (!this.events) return;
      if (this.dialog.open) this.dialog.close();
      this.cleanup();
      this.events.abort();
      this.events = null;
    }
  });
}
